<div class="report-designer-page page-container hidden-on-narrow" [hidden]="!options.isOnDisplay || options.isHidden">
  <ng-container *ngIf="!options.waitingForPrint">
    <div id="pdf-page-{{ footerPageNumber }}" class="pdf-page {{ options.name }} pdf-page-{{options.id}}">
      <div class="pdf-header">
        <!-- moved to RD mainPrint.html style header - easier to adjust positions -->
        <div class="header">
          <div class="widget-align-right" style="font-weight: bold; margin-top: 10px;">
          </div>
        </div>
      </div>
      <div class="pdf-footer">
        <table style="width: 100%; font-weight: bold; color: #898989;" aria-hidden="true">
          <tr>
            <td>COPYRIGHT &copy; JONES LANG LASALLE IP, INC. 2023. All Rights Reserved&nbsp;</td>
            <td class="widget-align-right pageNumber">{{ (footerPageNumber || 0) + 1}}&nbsp;</td>
          </tr>
        </table>
      </div>
      <div class="pdf-body" (mouseenter)="pageEntered()" (mouseleave)="pageLeft()">
        <gridster [options]="options"
                  class="gridster-container"
                  [class.highlightWidgetTargetFreeSpace]="widgetDropTargetEnabled"
                  [class.show-grid-raster]="isGridModeEnabled()"
                  (mousemove)="mouseMove($event)"
                  style="width: 100%; height: 100%;">
          <gridster-item *ngFor="let widget of widgets; trackBy: trackByWidgetId"
                         [item]="widget"
                         class="gridster-item"
                         [class.widget-activated]="document.main.activeWidget && widget.widgetSettings.id === document.main.activeWidget.widgetConfig.widgetSettings.id">
            <widget-box [main]="main" [widget]="widget" [document]="document" [page]="this" class="widget-box widget_id_{{widget.widgetSettings.id}}"></widget-box>
          </gridster-item>
        </gridster>
        <!-- Note: The drop target has a border of 2px on each side -> subtract them from the total size -->
        <div class="widgetDropTarget" *ngIf="widgetDropTargetEnabled" (click)="widgetDropTargetClicked()" (mousemove)="mouseMove($event)" (mouseenter)="mouseEnteredTarget()" (mouseleave)="mouseLeftTarget()"
             [style.width.px]="dropTarget.width - 2"
             [style.height.px]="dropTarget.height - 4"
             [style.top.px]="dropTarget.top"
             [style.left.px]="dropTarget.left"
             [class.dropTargetEnabled]="widgetDropTargetEnabled"
             [class.maxFreeSpaceAvailable]="maxFreeSpaceAvailable"
             [class.minFreeSpaceAvailable]="minFreeSpaceAvailable">
          <div class="widgetMinDropTarget" [style.width.px]="dropTarget.minWidth" [style.height.px]="dropTarget.minHeight"></div>
        </div>
      </div>
      <div class="page-break"></div>
      <div class="pdf-page-overlay" (click)="pageOverlayClicked()"></div>
    </div>
  </ng-container>
</div>
